import React from "react"

import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const"
import UserIcon from "../../../../gd-components/icons/user/user"

export default function FieldUser_QuickFilterView(props: FieldQuickFilterViewProps) {

    const {value} = props

    let icon = null
    let label = ''

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All users'
            break

        case null:
        case 'null':
            label = 'No user'
            break

        default:
            const user = gd.session.users.get(value);

            if (user) {
                icon = <UserIcon className="group-icon" userId={user.id} size="22"/>
                label = user.name
            } else {
                label = 'No user found'
            }
    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}